import { Queries } from 'gql';
import { createProjectProvider } from 'providers/createProjectProvider';

const { ProjectProvider, useCurrentProject, withProjectProvider } = createProjectProvider({
  getPhaseQuery: Queries.GET_LITE_PHASE,
});

const withLiteProjectProvider = withProjectProvider;

export { useCurrentProject, withLiteProjectProvider };

export default ProjectProvider;
